// Extracts the response body from a mutation error, if available
const getResponseBody = (error: unknown): Record<string, unknown> | undefined => {
  if (!error || typeof error !== 'object') return undefined;
  const data = (error as { data?: unknown }).data;
  return data && typeof data === 'object' ? (data as Record<string, unknown>) : undefined;
};

// Extracts the error message from a mutation error, if available
export const handleMutationError = (error: unknown): string => {
  const responseMessage = getResponseBody(error)?.message;
  if (typeof responseMessage === 'string') return responseMessage;

  const errorHasMessage =
    !!error &&
    typeof error === 'object' &&
    'message' in error &&
    typeof error['message'] === 'string';
  const errorMessage =
    errorHasMessage && typeof error['message'] === 'string'
      ? error.message
      : 'unknown error';
  return errorMessage;
};

export const handleMutationErrorTitle = (error: unknown): string | undefined => {
  const title = getResponseBody(error)?.title;
  return typeof title === 'string' ? title : undefined;
};

export enum MutationErrorTypes {
  NETWORK_ERROR = 'Network Error',
}
